var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDsBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "732.02pt",
    height: "293.29pt",
    viewBox: "0 0 732.02 293.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 669 157 L 732.019531 157 L 732.019531 245 L 669 245 Z M 669 157 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247 270 L 264 270 L 264 293.289063 L 247 293.289063 Z M 247 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 272 270 L 289 270 L 289 293.289063 L 272 293.289063 Z M 272 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 298 270 L 314 270 L 314 293.289063 L 298 293.289063 Z M 298 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 320 270 L 337 270 L 337 293.289063 L 320 293.289063 Z M 320 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 342 270 L 370 270 L 370 293.289063 L 342 293.289063 Z M 342 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 374 270 L 395 270 L 395 293.289063 L 374 293.289063 Z M 374 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 402 270 L 419 270 L 419 293.289063 L 402 293.289063 Z M 402 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 428 270 L 443 270 L 443 293.289063 L 428 293.289063 Z M 428 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 465 270 L 482 270 L 482 293.289063 L 465 293.289063 Z M 465 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 491 270 L 506 270 L 506 293.289063 L 491 293.289063 Z M 491 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 512 270 L 531 270 L 531 293.289063 L 512 293.289063 Z M 512 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 538 270 L 553 270 L 553 293.289063 L 538 293.289063 Z M 538 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 562 270 L 577 270 L 577 293.289063 L 562 293.289063 Z M 562 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 583 270 L 601 270 L 601 293.289063 L 583 293.289063 Z M 583 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 610 270 L 627 270 L 627 293.289063 L 610 293.289063 Z M 610 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 635 270 L 656 270 L 656 293.289063 L 635 293.289063 Z M 635 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 666 270 L 681 270 L 681 293.289063 L 666 293.289063 Z M 666 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 690 270 L 708 270 L 708 293.289063 L 690 293.289063 Z M 690 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 716 270 L 732.019531 270 L 732.019531 293.289063 L 716 293.289063 Z M 716 270 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 121 L 209 121 L 209 293.289063 L 0 293.289063 Z M 0 121 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 264.773438 122.265625 L 282.496094 122.265625 C 297.308594 122.265625 302.285156 107.332031 302.285156 93.007813 C 302.285156 67.273438 290.023438 65.210938 282.253906 65.210938 L 264.773438 65.210938 Z M 246.929688 50.15625 L 285.410156 50.15625 C 314.789063 50.15625 320.855469 75.164063 320.855469 91.671875 C 320.855469 110.367188 313.453125 137.316406 284.683594 137.316406 L 246.929688 137.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 368.925781 104.175781 C 367.226563 105.511719 364.433594 106.605469 357.394531 107.695313 C 351.078125 108.789063 345.859375 110.367188 345.859375 117.410156 C 345.859375 123.355469 350.472656 125.175781 353.75 125.175781 C 361.277344 125.175781 368.925781 120.320313 368.925781 112.429688 Z M 385.554688 122.992188 C 385.554688 130.640625 387.253906 134.039063 389.320313 134.769531 L 389.320313 137.316406 L 370.988281 137.316406 C 370.019531 134.28125 369.773438 131.609375 369.410156 127.96875 C 365.527344 131.976563 360.0625 137.316406 348.53125 137.316406 C 338.820313 137.316406 328.867188 131.855469 328.867188 118.5 C 328.867188 105.875 336.878906 99.441406 347.679688 97.863281 L 362.976563 95.558594 C 365.644531 95.195313 368.925781 94.101563 368.925781 90.460938 C 368.925781 83.296875 362.128906 82.933594 357.757813 82.933594 C 349.257813 82.933594 347.804688 88.152344 347.316406 91.914063 L 330.929688 91.914063 C 332.871094 72.128906 346.589844 69.335938 359.820313 69.335938 C 368.925781 69.335938 385.554688 72.128906 385.554688 88.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 459.113281 137.273438 L 442.121094 137.273438 L 442.121094 96.40625 C 442.121094 91.671875 441.878906 83.660156 431.070313 83.660156 C 423.546875 83.660156 417.71875 88.761719 417.71875 98.59375 L 417.71875 137.273438 L 400.722656 137.273438 L 400.722656 69.335938 L 416.992188 69.335938 L 416.992188 80.503906 L 417.234375 80.503906 C 419.539063 76.621094 424.394531 69.335938 436.65625 69.335938 C 449.28125 69.335938 459.113281 76.742188 459.113281 90.945313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 475.378906 65.9375 L 492.375 65.9375 L 492.375 50.15625 L 475.378906 50.15625 Z M 475.378906 65.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 475.378906 137.316406 L 492.375 137.316406 L 492.375 72.734375 L 475.378906 72.734375 Z M 475.378906 137.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 547.363281 96.894531 C 546.390625 86.453125 539.714844 83.296875 534.253906 83.296875 C 526.238281 83.296875 521.992188 88.394531 521.019531 96.894531 Z M 564.113281 116.679688 C 559.621094 132.21875 546.753906 137.316406 535.707031 137.316406 C 517.5 137.316406 503.539063 128.574219 503.539063 101.992188 C 503.539063 94.222656 506.210938 69.335938 534.492188 69.335938 C 547.242188 69.335938 564.84375 75.40625 564.84375 104.90625 L 564.84375 107.941406 L 520.535156 107.941406 C 521.019531 112.796875 521.992188 123.722656 535.707031 123.722656 C 540.441406 123.722656 545.296875 121.292969 546.632813 116.679688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 576.613281 137.316406 L 593.609375 137.316406 L 593.609375 50.15625 L 576.613281 50.15625 Z M 576.613281 137.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 263.53125 217.050781 C 263.648438 221.660156 265.953125 230.425781 281.054688 230.425781 C 289.242188 230.425781 298.351563 228.464844 298.351563 219.703125 C 298.351563 213.246094 292.125 211.515625 283.363281 209.441406 L 274.484375 207.367188 C 261.109375 204.253906 248.199219 201.253906 248.199219 183.039063 C 248.199219 173.816406 253.15625 157.558594 280.019531 157.558594 C 305.382813 157.558594 312.183594 174.160156 312.300781 184.308594 L 295.699219 184.308594 C 295.238281 180.617188 293.851563 171.855469 278.75 171.855469 C 272.179688 171.855469 264.339844 174.277344 264.339844 181.769531 C 264.339844 188.226563 269.640625 189.609375 273.101563 190.417969 L 293.277344 195.375 C 304.574219 198.140625 314.953125 202.753906 314.953125 217.625 C 314.953125 242.527344 289.589844 244.71875 282.324219 244.71875 C 252.117188 244.71875 246.929688 227.3125 246.929688 217.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 343.269531 176.738281 L 353.832031 176.738281 L 353.832031 188.878906 L 343.269531 188.878906 L 343.269531 226.632813 C 343.269531 230.394531 343.394531 231.851563 350.3125 231.851563 C 351.40625 231.851563 352.617188 231.730469 353.832031 231.609375 L 353.832031 244.476563 C 351.164063 244.597656 348.492188 244.71875 345.820313 244.71875 L 343.636719 244.71875 C 328.949219 244.71875 326.277344 239.136719 326.277344 230.761719 L 326.277344 188.878906 L 317.535156 188.878906 L 317.535156 176.738281 L 326.277344 176.738281 L 326.277344 157.558594 L 343.269531 157.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 397.921875 211.578125 C 396.222656 212.914063 393.429688 214.007813 386.390625 215.097656 C 380.078125 216.191406 374.855469 217.769531 374.855469 224.8125 C 374.855469 230.757813 379.472656 232.582031 382.746094 232.582031 C 390.273438 232.582031 397.921875 227.722656 397.921875 219.835938 Z M 414.554688 230.394531 C 414.554688 238.042969 416.253906 241.441406 418.316406 242.171875 L 418.316406 244.71875 L 399.984375 244.71875 C 399.015625 241.683594 398.773438 239.015625 398.410156 235.371094 C 394.523438 239.378906 389.0625 244.71875 377.527344 244.71875 C 367.816406 244.71875 357.863281 239.257813 357.863281 225.902344 C 357.863281 213.277344 365.875 206.84375 376.679688 205.265625 L 391.976563 202.960938 C 394.644531 202.597656 397.921875 201.503906 397.921875 197.863281 C 397.921875 190.699219 391.125 190.335938 386.753906 190.335938 C 378.257813 190.335938 376.800781 195.554688 376.3125 199.320313 L 359.925781 199.320313 C 361.867188 179.53125 375.585938 176.738281 388.816406 176.738281 C 397.921875 176.738281 414.554688 179.53125 414.554688 195.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 482.199219 244.71875 L 465.203125 244.71875 L 465.203125 203.808594 C 465.203125 199.074219 464.960938 191.066406 454.15625 191.066406 C 446.628906 191.066406 440.804688 196.164063 440.804688 205.996094 L 440.804688 244.71875 L 423.808594 244.71875 L 423.808594 176.738281 L 440.074219 176.738281 L 440.074219 187.90625 L 440.316406 187.90625 C 442.625 184.023438 447.480469 176.738281 459.738281 176.738281 C 472.363281 176.738281 482.199219 184.144531 482.199219 198.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 520.9375 230.757813 C 531.738281 230.757813 535.988281 221.777344 535.988281 212.1875 C 535.988281 201.867188 533.074219 191.429688 521.421875 191.429688 C 510.617188 191.429688 506.976563 201.019531 506.976563 211.214844 C 506.976563 218.863281 510.011719 230.757813 520.9375 230.757813 M 552.253906 244.71875 L 535.625 244.71875 L 535.625 234.886719 L 535.382813 234.886719 C 531.253906 242.171875 523.726563 244.71875 516.6875 244.71875 C 497.507813 244.71875 489.496094 227.722656 489.496094 210 C 489.496094 187.664063 502.121094 176.738281 516.324219 176.738281 C 527.246094 176.738281 532.347656 182.6875 535.015625 186.816406 L 535.261719 186.816406 L 535.261719 157.558594 L 552.253906 157.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 600.6875 211.578125 C 598.988281 212.914063 596.195313 214.007813 589.152344 215.097656 C 582.839844 216.191406 577.621094 217.769531 577.621094 224.8125 C 577.621094 230.757813 582.234375 232.582031 585.511719 232.582031 C 593.039063 232.582031 600.6875 227.722656 600.6875 219.835938 Z M 617.316406 230.394531 C 617.316406 238.042969 619.015625 241.441406 621.078125 242.171875 L 621.078125 244.71875 L 602.75 244.71875 C 601.777344 241.683594 601.535156 239.015625 601.171875 235.371094 C 597.285156 239.378906 591.824219 244.71875 580.292969 244.71875 C 570.582031 244.71875 560.628906 239.257813 560.628906 225.902344 C 560.628906 213.277344 568.636719 206.84375 579.441406 205.265625 L 594.738281 202.960938 C 597.40625 202.597656 600.6875 201.503906 600.6875 197.863281 C 600.6875 190.699219 593.886719 190.335938 589.519531 190.335938 C 581.019531 190.335938 579.5625 195.554688 579.078125 199.320313 L 562.691406 199.320313 C 564.632813 179.53125 578.351563 176.738281 591.582031 176.738281 C 600.6875 176.738281 617.316406 179.53125 617.316406 195.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 629.339844 176.738281 L 645.609375 176.738281 L 645.609375 189.609375 L 645.851563 189.609375 C 649.371094 183.050781 653.253906 176.738281 663.574219 176.738281 C 664.664063 176.738281 665.757813 176.859375 666.851563 176.984375 L 666.851563 194.21875 C 665.394531 193.976563 663.574219 193.976563 661.996094 193.976563 C 648.765625 193.976563 646.335938 202.230469 646.335938 209.394531 L 646.335938 244.71875 L 629.339844 244.71875 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(48.234558%,52.548218%,55.293274%)",
      fillOpacity: 1
    },
    d: "M 700.703125 230.757813 C 711.503906 230.757813 715.753906 221.777344 715.753906 212.1875 C 715.753906 201.867188 712.839844 191.429688 701.1875 191.429688 C 690.382813 191.429688 686.742188 201.019531 686.742188 211.214844 C 686.742188 218.863281 689.777344 230.757813 700.703125 230.757813 M 732.019531 244.71875 L 715.390625 244.71875 L 715.390625 234.886719 L 715.148438 234.886719 C 711.019531 242.171875 703.492188 244.71875 696.453125 244.71875 C 677.273438 244.71875 669.261719 227.722656 669.261719 210 C 669.261719 187.664063 681.886719 176.738281 696.089844 176.738281 C 707.015625 176.738281 712.113281 182.6875 714.785156 186.816406 L 715.023438 186.816406 L 715.023438 157.558594 L 732.019531 157.558594 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 255.613281 293.289063 C 252.226563 293.289063 249.785156 292.5 247.632813 290.3125 L 249.914063 288.0625 C 251.558594 289.710938 253.363281 290.21875 255.679688 290.21875 C 258.625 290.21875 260.335938 288.949219 260.335938 286.761719 C 260.335938 285.78125 260.050781 284.957031 259.449219 284.417969 C 258.878906 283.882813 258.308594 283.660156 256.980469 283.46875 L 254.316406 283.085938 C 252.480469 282.835938 251.023438 282.203125 250.039063 281.28125 C 248.929688 280.238281 248.394531 278.8125 248.394531 276.972656 C 248.394531 273.046875 251.242188 270.351563 255.933594 270.351563 C 258.910156 270.351563 261.003906 271.113281 262.933594 272.917969 L 260.746094 275.074219 C 259.355469 273.742188 257.738281 273.332031 255.835938 273.332031 C 253.175781 273.332031 251.71875 274.851563 251.71875 276.847656 C 251.71875 277.671875 251.972656 278.398438 252.574219 278.9375 C 253.144531 279.445313 254.0625 279.828125 255.109375 279.980469 L 257.675781 280.363281 C 259.765625 280.679688 260.9375 281.1875 261.890625 282.042969 C 263.125 283.121094 263.726563 284.734375 263.726563 286.667969 C 263.726563 290.816406 260.335938 293.289063 255.613281 293.289063 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 284.027344 274.820313 C 283.230469 273.960938 281.996094 273.421875 280.664063 273.421875 C 279.335938 273.421875 278.101563 273.960938 277.308594 274.820313 C 276.199219 276.023438 275.980469 277.292969 275.980469 281.824219 C 275.980469 286.351563 276.199219 287.617188 277.308594 288.820313 C 278.101563 289.675781 279.335938 290.21875 280.664063 290.21875 C 281.996094 290.21875 283.230469 289.675781 284.027344 288.820313 C 285.136719 287.617188 285.355469 286.351563 285.355469 281.824219 C 285.355469 277.292969 285.136719 276.023438 284.027344 274.820313 M 286.621094 290.878906 C 285.070313 292.433594 283.074219 293.289063 280.664063 293.289063 C 278.261719 293.289063 276.296875 292.433594 274.742188 290.878906 C 272.523438 288.664063 272.554688 286.164063 272.554688 281.824219 C 272.554688 277.480469 272.523438 274.976563 274.742188 272.761719 C 276.296875 271.207031 278.261719 270.351563 280.664063 270.351563 C 283.074219 270.351563 285.070313 271.207031 286.621094 272.761719 C 288.84375 274.976563 288.777344 277.480469 288.777344 281.824219 C 288.777344 286.164063 288.84375 288.664063 286.621094 290.878906 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 302.332031 273.613281 L 302.332031 280.488281 L 311.710938 280.488281 L 311.710938 283.5625 L 302.332031 283.5625 L 302.332031 293.101563 L 298.910156 293.101563 L 298.910156 270.542969 L 313.328125 270.542969 L 313.328125 273.613281 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 330.144531 273.613281 L 330.144531 293.101563 L 326.71875 293.101563 L 326.71875 273.613281 L 320.511719 273.613281 L 320.511719 270.542969 L 336.351563 270.542969 L 336.351563 273.613281 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 363.714844 293.097656 L 360.738281 293.097656 L 356.140625 277.292969 L 351.578125 293.097656 L 348.605469 293.097656 L 342.710938 270.542969 L 346.324219 270.542969 L 350.25 286.667969 L 354.78125 270.542969 L 357.535156 270.542969 L 362.066406 286.667969 L 365.996094 270.542969 L 369.605469 270.542969 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 384.546875 275.640625 L 381.03125 285.65625 L 387.96875 285.65625 Z M 390.472656 293.097656 L 388.921875 288.570313 L 380.019531 288.570313 L 378.464844 293.097656 L 374.820313 293.097656 L 383.09375 270.542969 L 385.847656 270.542969 L 394.117188 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 410.867188 273.613281 L 405.800781 273.613281 L 405.800781 280.679688 L 410.867188 280.679688 C 413.148438 280.679688 414.703125 279.382813 414.703125 277.164063 C 414.703125 274.945313 413.148438 273.613281 410.867188 273.613281 M 414.828125 293.101563 L 410.078125 283.59375 L 405.800781 283.59375 L 405.800781 293.101563 L 402.378906 293.101563 L 402.378906 270.542969 L 411.121094 270.542969 C 415.398438 270.542969 418.125 273.300781 418.125 277.132813 C 418.125 280.363281 416.160156 282.421875 413.625 283.121094 L 418.820313 293.101563 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 428.191406 293.097656 L 428.191406 270.542969 L 442.605469 270.542969 L 442.605469 273.613281 L 431.609375 273.613281 L 431.609375 280.203125 L 440.988281 280.203125 L 440.988281 283.246094 L 431.609375 283.246094 L 431.609375 290.027344 L 442.605469 290.027344 L 442.605469 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 476.433594 275.136719 C 475.480469 274.089844 474.214844 273.613281 472.59375 273.613281 L 468.445313 273.613281 L 468.445313 290.027344 L 472.59375 290.027344 C 474.214844 290.027344 475.480469 289.550781 476.433594 288.503906 C 477.601563 287.207031 477.632813 284.765625 477.632813 281.664063 C 477.632813 278.558594 477.601563 276.433594 476.433594 275.136719 M 478.773438 290.976563 C 477.347656 292.402344 475.289063 293.101563 472.945313 293.101563 L 465.027344 293.101563 L 465.027344 270.542969 L 472.945313 270.542969 C 475.289063 270.542969 477.347656 271.238281 478.773438 272.664063 C 481.214844 275.105469 481.058594 278.398438 481.058594 281.664063 C 481.058594 284.925781 481.214844 288.539063 478.773438 290.976563 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 491.183594 293.097656 L 491.183594 270.542969 L 505.601563 270.542969 L 505.601563 273.613281 L 494.605469 273.613281 L 494.605469 280.203125 L 503.984375 280.203125 L 503.984375 283.246094 L 494.605469 283.246094 L 494.605469 290.027344 L 505.601563 290.027344 L 505.601563 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 522.636719 293.097656 L 519.976563 293.097656 L 512.566406 270.542969 L 516.113281 270.542969 L 521.308594 286.953125 L 526.503906 270.542969 L 530.117188 270.542969 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 538.28125 293.097656 L 538.28125 270.542969 L 552.699219 270.542969 L 552.699219 273.613281 L 541.703125 273.613281 L 541.703125 280.203125 L 551.082031 280.203125 L 551.082031 283.246094 L 541.703125 283.246094 L 541.703125 290.027344 L 552.699219 290.027344 L 552.699219 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 562.449219 293.097656 L 562.449219 270.542969 L 565.867188 270.542969 L 565.867188 290.027344 L 576.734375 290.027344 L 576.734375 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 595.386719 274.820313 C 594.597656 273.960938 593.359375 273.421875 592.027344 273.421875 C 590.699219 273.421875 589.460938 273.960938 588.671875 274.820313 C 587.5625 276.023438 587.339844 277.292969 587.339844 281.824219 C 587.339844 286.351563 587.5625 287.617188 588.671875 288.820313 C 589.460938 289.675781 590.699219 290.21875 592.027344 290.21875 C 593.359375 290.21875 594.597656 289.675781 595.386719 288.820313 C 596.496094 287.617188 596.71875 286.351563 596.71875 281.824219 C 596.71875 277.292969 596.496094 276.023438 595.386719 274.820313 M 597.984375 290.878906 C 596.433594 292.433594 594.4375 293.289063 592.027344 293.289063 C 589.621094 293.289063 587.65625 292.433594 586.105469 290.878906 C 583.886719 288.664063 583.917969 286.164063 583.917969 281.824219 C 583.917969 277.480469 583.886719 274.976563 586.105469 272.761719 C 587.65625 271.207031 589.621094 270.351563 592.027344 270.351563 C 594.4375 270.351563 596.433594 271.207031 597.984375 272.761719 C 600.203125 274.976563 600.136719 277.480469 600.136719 281.824219 C 600.136719 286.164063 600.203125 288.664063 597.984375 290.878906 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 618.636719 273.613281 L 613.691406 273.613281 L 613.691406 281.125 L 618.636719 281.125 C 621.011719 281.125 622.628906 279.761719 622.628906 277.386719 C 622.628906 275.011719 621.011719 273.613281 618.636719 273.613281 M 618.824219 284.230469 L 613.691406 284.230469 L 613.691406 293.101563 L 610.273438 293.101563 L 610.273438 270.542969 L 618.824219 270.542969 C 623.230469 270.542969 626.050781 273.453125 626.050781 277.386719 C 626.050781 281.316406 623.230469 284.230469 618.824219 284.230469 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 651.734375 293.097656 L 651.734375 278.015625 L 646.539063 289.011719 L 644.003906 289.011719 L 638.683594 278.015625 L 638.683594 293.097656 L 635.261719 293.097656 L 635.261719 270.542969 L 638.683594 270.542969 L 645.269531 284.574219 L 651.734375 270.542969 L 655.15625 270.542969 L 655.15625 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 666.078125 293.097656 L 666.078125 270.542969 L 680.496094 270.542969 L 680.496094 273.613281 L 669.5 273.613281 L 669.5 280.203125 L 678.878906 280.203125 L 678.878906 283.246094 L 669.5 283.246094 L 669.5 290.027344 L 680.496094 290.027344 L 680.496094 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 704.089844 293.097656 L 693.664063 277.226563 L 693.664063 293.097656 L 690.246094 293.097656 L 690.246094 270.542969 L 693.378906 270.542969 L 703.804688 286.382813 L 703.804688 270.542969 L 707.226563 270.542969 L 707.226563 293.097656 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 725.8125 273.613281 L 725.8125 293.101563 L 722.390625 293.101563 L 722.390625 273.613281 L 716.183594 273.613281 L 716.183594 270.542969 L 732.019531 270.542969 L 732.019531 273.613281 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 141.039063 -0.00390625 L 10.164063 -0.00390625 C 4.550781 -0.00390625 0 4.550781 0 10.160156 L 0 101.425781 C 0 111.0625 5.203125 119.953125 13.605469 124.675781 L 47.941406 143.964844 C 49.066406 144.597656 50.460938 143.785156 50.460938 142.492188 L 50.460938 59.691406 C 50.460938 54.589844 54.59375 50.457031 59.691406 50.457031 L 148.648438 50.457031 C 153.746094 50.457031 157.878906 54.589844 157.878906 59.691406 L 157.878906 118.878906 C 157.878906 120.152344 158.570313 121.328125 159.679688 121.953125 L 203.4375 146.539063 C 205.632813 147.769531 208.339844 146.1875 208.339844 143.671875 L 208.339844 67.300781 C 208.339844 30.128906 178.207031 -0.00390625 141.039063 -0.00390625 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 194.730469 168.367188 L 157.878906 147.664063 L 157.878906 147.6875 L 117.558594 125.03125 C 105.445313 118.230469 89.734375 121.867188 82.710938 133.851563 C 75.554688 146.0625 79.828125 161.714844 92.113281 168.613281 L 151.769531 202.132813 C 155.542969 204.25 157.878906 208.242188 157.878906 212.570313 L 157.878906 233.597656 C 157.878906 238.699219 153.746094 242.832031 148.648438 242.832031 L 59.691406 242.832031 C 54.59375 242.832031 50.460938 238.699219 50.460938 233.597656 L 50.460938 173.902344 C 50.460938 172.789063 49.855469 171.761719 48.886719 171.214844 L 5.347656 146.753906 C 2.953125 145.410156 0 147.136719 0 149.882813 L 0 283.125 C 0 288.738281 4.550781 293.289063 10.164063 293.289063 L 141.035156 293.289063 C 178.207031 293.289063 208.339844 263.160156 208.339844 225.988281 L 208.339844 191.617188 C 208.339844 181.980469 203.136719 173.089844 194.730469 168.367188 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 112.136719 226.367188 C 112.136719 221.96875 108.570313 218.402344 104.167969 218.402344 C 99.769531 218.402344 96.203125 221.96875 96.203125 226.367188 C 96.203125 230.769531 99.769531 234.335938 104.167969 234.335938 C 108.570313 234.335938 112.136719 230.769531 112.136719 226.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,30.587769%,44.7052%)",
      fillOpacity: 1
    },
    d: "M 112.40625 65.765625 C 113.820313 65.765625 114.964844 64.621094 114.964844 63.207031 L 114.964844 62.871094 C 114.964844 61.460938 113.820313 60.316406 112.40625 60.316406 L 95.929688 60.316406 C 94.519531 60.316406 93.375 61.460938 93.375 62.871094 L 93.375 63.207031 C 93.375 64.621094 94.519531 65.765625 95.929688 65.765625 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsBrand);
export default __webpack_public_path__ + "static/media/ds-brand.64a2ec6cd27c0f4c145f1d939942ab03.svg";
export { ForwardRef as ReactComponent };